export default __webpack_public_path__ + "static/telemed2-3a7445d62477a9928ae5036256d0178b.jpg";